import React from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  // const [PDf, setPDF] = React.useState(FetchData.meta.book_pdf)
  // const [Author, setAuthor] = React.useState(FetchData.meta.book_author)
  // const [PublishedDate, setPublishedDate] = React.useState(FetchData.meta.book_published_date)
  // const [AboutBook, setAboutBook] = React.useState(FetchData.meta.about_book)

  const [VideoYoutubeUrl, setYoutubeUrl] = React.useState(FetchData.meta.video_youtube_url)
  const [VideoYoutubeID, setYoutubeID] = React.useState(FetchData.meta.youtube_id)
  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")
  //  const youtubeURL = (url)=>{
  //    return     /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/

  //  }
  function YouTubeGetID(url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined)
        setYoutubeID(url[2].split(/[^0-9a-z_\-]/i)[0])
      // console.log(url[2].split(/[^0-9a-z_\-]/i)[0])
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  }

  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "vide_title": Title,
        "video_youtube_url": `${VideoYoutubeUrl}`,
        "youtube_id": `${VideoYoutubeID}`,
        "youtube_date": "",
        "about_video": "",
        "video_type":"All"
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_videos)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Book Added Successfully")
          history.push(`${slugs.video_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_videos, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Video Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Youtube Url</td>
                <td className="col-6">
                  <input className="input-common"
                    value={VideoYoutubeUrl} placeholder="Videop Url"
                    onChange={(event) => {
                      setYoutubeUrl(event.target.value)
                      YouTubeGetID(event.target.value)
                    }}
                  />
                </td>
              </tr>
              {/* {YouTubeGetID(VideoYoutubeUrl)} */}
              <tr>
                <td className="col-3">Youtube ID</td>
                <td className="col-6">
                  <input className="input-common"
                    value={VideoYoutubeID} placeholder="Youtube Video ID"
                    onChange={(event) => {
                      setYoutubeID(event.target.value)
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Video
              </div>
            </div>
          </div>
        </div>
      </div>

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div>
  )

}